module.exports = __webpack_public_path__ + "img/logo_gobierno.51eb0499.png";